import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthFormComponent } from './auth-form.component';
import { MatButtonModule, MatInputModule } from '@angular/material';
import { AuthErrorComponent } from './auth-error/auth-error.component';

@NgModule({
  declarations: [
    AuthFormComponent,
    AuthErrorComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
  ],

  exports: [AuthFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AuthFormModule {
}
